// Translations
import { useTrans } from "@/i18n"

// UI
import { cn } from "@/lib/utils"
import { Checkbox } from "@/components/form-controls/Checkbox"

// Sentry
import { SentryReplayPrivacyClassNames } from "@/lib/sentry"

/**
 * ExpertExperienceLevelPrivate
 * @returns
 */
export const ExpertExperienceLevelPrivate = ({
	privateCriteria,
	setPrivateCriteria,
}: {
	privateCriteria: { item1: boolean; item2: boolean; item3: boolean }
	setPrivateCriteria: React.Dispatch<
		React.SetStateAction<{
			item1: boolean
			item2: boolean
			item3: boolean
		}>
	>
}) => {
	// i18n
	const t = useTrans("investor")

	return (
		<div
			className={cn(
				"mt-4",
				"sentry-block" as SentryReplayPrivacyClassNames,
			)}
		>
			<strong className="font-bold">
				{t("investor:investor.profile.choice.expert.private.title")}
			</strong>
			<br />
			{t("investor:investor.profile.choice.expert.private.subtitle")}
			<div className="mt-2 space-y-2">
				<div className="flex items-start gap-2">
					<Checkbox
						checked={privateCriteria.item1}
						onChange={(e) =>
							setPrivateCriteria(
								(prev: {
									item1: boolean
									item2: boolean
									item3: boolean
								}) => ({
									...prev,
									item1: e.target.checked,
								}),
							)
						}
						className="mt-0.5"
					/>
					<span className="select-none text-sm">
						{t(
							"investor:investor.profile.choice.expert.private.list.item1",
						)}
					</span>
				</div>
				<div className="flex items-start gap-2">
					<Checkbox
						checked={privateCriteria.item2}
						onChange={(e) =>
							setPrivateCriteria(
								(prev: {
									item1: boolean
									item2: boolean
									item3: boolean
								}) => ({
									...prev,
									item2: e.target.checked,
								}),
							)
						}
						className="mt-0.5"
					/>
					<span className="select-none text-sm">
						{t(
							"investor:investor.profile.choice.expert.private.list.item2",
						)}
					</span>
				</div>
				<div className="flex items-start gap-2">
					<Checkbox
						checked={privateCriteria.item3}
						onChange={(e) =>
							setPrivateCriteria(
								(prev: {
									item1: boolean
									item2: boolean
									item3: boolean
								}) => ({
									...prev,
									item3: e.target.checked,
								}),
							)
						}
						className="mt-0.5"
					/>
					<span className="select-none text-sm">
						{t(
							"investor:investor.profile.choice.expert.private.list.item3",
						)}
					</span>
				</div>
			</div>
		</div>
	)
}
